export default __webpack_public_path__ + "static/media/collegegiri.51ac4caf.png";